export function createCookie(name, value, days, path) {
	let expires = '';

	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = '; expires=' + date.toGMTString();
	} else {
		expires = '';
	}

	document.cookie = name + '=' + value + expires + '; path=' + path;
}

export function readCookie(name) {
	var nameEQ = name + '=';
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}

export function deleteCookie(name, path, domain) {
	if (readCookie(name)) {
		document.cookie =
			name +
			'=' +
			(path ? ';path=' + path : '') +
			(domain ? ';domain=' + domain : '') +
			';expires=Thu, 01 Jan 1970 00:00:01 GMT';
	}
}
